import { gql } from '@apollo/client';
import { useQueryPromise } from '@starrez/starryutils';

export const LazyAllCategories = gql`
    query LazyAllCategories {
        allCategories {
            nodes {
                id
                description
            }
        }
    }
`;

interface ICategory {
    id: string;
    description: string;
}

export interface ICategoriesList {
    allCategories: {
        nodes: ICategory[];
    }
}

export const useLazyAllCategories = () => useQueryPromise<ICategoriesList>(LazyAllCategories);
